import { UserSecurityApiClient } from '@fourthwall/services/dist/UserSecurityApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteUserSecuritySessionMutation = createMutationHook(
  UserSecurityApiClient.deleteUserSecuritySession,
  {
    mutationKey: ['deleteUserSecuritySession'],
  },
)
